import { render } from "./LayoutMain.vue?vue&type=template&id=55e2ff17&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=ts"
export * from "./LayoutMain.vue?vue&type=script&lang=ts"

import "./LayoutMain.vue?vue&type=style&index=0&id=55e2ff17&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55e2ff17"

export default script